import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'

type FormSummarySectionProps = {
  label: string
}

export const FormSummarySection: FC<React.PropsWithChildren<FormSummarySectionProps>> = ({
  label,
  children,
}) => (
  <>
    <div className="wrapper">
      <Text variant={TextVariant.caption} className="text-block" fontWeight={TextFontWeight.bold}>
        {label}
      </Text>
      <div className="content">{children}</div>
    </div>

    <style jsx>{`
      .wrapper + .wrapper {
        margin-top: ${theme.spacing[4]};
      }
      .content {
        margin-top: ${theme.spacing[3]};
      }
    `}</style>
  </>
)
